import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  colorScheme: 'LIGHT',
  idleTime: {
    ideal_time_check: false,
    customerID: ''
  },
  travelModal: {
    show: false,
    triggeredByOCR: false
  },
  posDateErrorModal: {
    show: false,
    invalidRows: [],
    message: ''
  },
  categorizingCount: 0
}

export const global = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setColorScheme: (state, { payload }) => {
      state.colorScheme = payload
    },
    setIdleTime: (state, { payload }) => {
      state.idleTime = payload
    },
    setTravelModal: (state, { payload }) => {
      state.travelModal.show = payload.show
      state.travelModal.triggeredByOCR = payload.triggeredByOCR || false
    },
    hideTravelModal: (state) => {
      state.travelModal.show = false
      state.travelModal.triggeredByOCR = false
    },
    showPosDateErrorModal: (state, { payload }) => {
      state.posDateErrorModal.show = true
      state.posDateErrorModal.invalidRows = payload?.invalidRows || []
      state.posDateErrorModal.message = payload?.message || ''
    },
    hidePosDateErrorModal: state => {
      state.posDateErrorModal = initialState.posDateErrorModal
    },
    startCategorizing: state => {
      state.categorizingCount += 1
    },
    finishCategorizing: state => {
      state.categorizingCount = Math.max(0, state.categorizingCount - 1)
    },
    resetCategorizing: state => {
      state.categorizingCount = 0
    },
    resetGlobal: () => initialState
  }
})

export const {
  setColorScheme,
  setIdleTime,
  setTravelModal,
  hideTravelModal,
  showPosDateErrorModal,
  hidePosDateErrorModal,
  startCategorizing,
  finishCategorizing,
  resetCategorizing,
  resetGlobal
} = global.actions

export const selectGlobal = state => state.global
export const selectColorScheme = state => state.global.colorScheme
export const selectIdleTime = state => state.global.idleTime
export const selectTravelModal = state => state.global.travelModal
export const selectPosDateErrorModal = state => state.global.posDateErrorModal
export const selectIsCategorizing = state =>
  state.global.categorizingCount > 0

export default global.reducer
